// import React, { useState, useEffect } from 'react';
// import Papa from "papaparse";


// const UploadComponent = () => {
//   const [filesData, setFilesData] = useState([]);
//   const [selectedDate, setSelectedDate] = useState('');

//   useEffect(() => {
//     const savedFiles = localStorage.getItem("csvFilesData");
//     if (savedFiles) {
//       setFilesData(JSON.parse(savedFiles));
//     }
//   }, []);

//   useEffect(() => {
//     if (filesData.length > 0) {
//       localStorage.setItem("csvFilesData", JSON.stringify(filesData));
//     }
//   }, [filesData]);

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     Papa.parse(file, {
//       header: true,
//       skipEmptyLines: true,
//       complete: function (results) {
//         const headers = Object.keys(results.data[0]);
//         const newFile = {
//           id: Date.now(),
//           fileName: file.name,
//           headers,
//           tableData: results.data,
//           submitted: false,
//           editRowIndex: null,
//           editRowData: {},
//           uploadDate: new Date().toISOString().split('T')[0],
//         };
//         setFilesData((prev) => [...prev, newFile]);
//       },
//     });

//     e.target.value = "";
//   };

//   const updateFileData = (id, updatedFields) => {
//     setFilesData((prev) =>
//       prev.map((file) =>
//         file.id === id ? { ...file, ...updatedFields } : file
//       )
//     );
//   };

//   const handleEditClick = (fileId, rowIndex) => {
//     const file = filesData.find((f) => f.id === fileId);
//     updateFileData(fileId, {
//       editRowIndex: rowIndex,
//       editRowData: { ...file.tableData[rowIndex] },
//     });
//   };

//   const handleInputChange = (e, fileId, field) => {
//     const file = filesData.find((f) => f.id === fileId);
//     const updatedEditData = {
//       ...file.editRowData,
//       [field]: e.target.value,
//     };
//     updateFileData(fileId, { editRowData: updatedEditData });
//   };

//   const handleSave = (fileId) => {
//     const file = filesData.find((f) => f.id === fileId);
//     const updatedTable = [...file.tableData];
//     updatedTable[file.editRowIndex] = file.editRowData;
//     updateFileData(fileId, {
//       tableData: updatedTable,
//       editRowIndex: null,
//       editRowData: {},
//     });
//   };

//   const handleCancel = (fileId) => {
//     updateFileData(fileId, { editRowIndex: null, editRowData: {} });
//   };

//   const handleDeleteRow = (fileId, rowIndex) => {
//     const file = filesData.find((f) => f.id === fileId);
//     const updatedTable = [...file.tableData];
//     updatedTable.splice(rowIndex, 1);
//     updateFileData(fileId, { tableData: updatedTable });
//   };

//   const handleFinalSubmit = (fileId) => {
//     updateFileData(fileId, { submitted: true });
//     alert("File submitted!");
//   };

//   const handleEditFile = (fileId) => {
//     updateFileData(fileId, { submitted: false });
//   };

//   const handleDeleteFile = (fileId) => {
//     setFilesData((prev) => prev.filter((f) => f.id !== fileId));
//   };

//   const handleSelectDate = (e) => {
//     setSelectedDate(e.target.value);
//   };

//   const filteredFiles = selectedDate
//     ? filesData.filter((file) => file.uploadDate === selectedDate)
//     : filesData;

//   const uniqueDates = [
//     ...new Set(filesData.map((file) => file.uploadDate)),
//   ];

//   return (
//     <div className="p-6 space-y-6">
//       <h2 className="text-2xl font-bold mb-2">All Files</h2>

      

//       <input
//         type="file"
//         accept=".csv"
//         onChange={handleFileChange}
//         className="file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
//       />

//       {filteredFiles.map((file) => (
//         <div key={file.id} className="border p-4 rounded-md bg-gray-50">
//           {file.submitted ? (
//             <div className="flex items-center justify-between">
//               <p className="font-medium">{file.fileName}</p>
//               <div className="flex gap-2">
//                 <button
//                   onClick={() => handleEditFile(file.id)}
//                   className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
//                 >
//                   Edit
//                 </button>
//                 <button
//                   onClick={() => handleDeleteFile(file.id)}
//                   className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           ) : (
//             <>
//               <div className="mb-3">
//                 <button
//                   onClick={() => handleFinalSubmit(file.id)}
//                   className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
//                 >
//                   Final Submission
//                 </button>
//               </div>

//               <div className="overflow-auto border rounded-lg">
//                 <table className="min-w-full border-collapse">
//                   <thead>
//                     <tr className="bg-gray-100 text-left text-sm font-medium text-gray-700">
//                       {file.headers.map((head, i) => (
//                         <th key={i} className="border px-4 py-2">
//                           {head}
//                         </th>
//                       ))}
//                       <th className="border px-4 py-2">Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {file.tableData.map((row, rowIndex) => (
//                       <tr
//                         key={rowIndex}
//                         className={rowIndex % 2 === 0 ? "bg-white" : "bg-gray-50"}
//                       >
//                         {file.headers.map((head, colIndex) => (
//                           <td key={colIndex} className="border px-4 py-2 text-sm">
//                             {file.editRowIndex === rowIndex ? (
//                               <input
//                                 type="text"
//                                 value={file.editRowData[head]}
//                                 onChange={(e) =>
//                                   handleInputChange(e, file.id, head)
//                                 }
//                                 className="w-full border px-2 py-1 text-sm rounded"
//                               />
//                             ) : (
//                               row[head]
//                             )}
//                           </td>
//                         ))}
//                         <td className="border px-4 py-2 text-sm">
//                           {file.editRowIndex === rowIndex ? (
//                             <div className="flex gap-2">
//                               <button
//                                 onClick={() => handleSave(file.id)}
//                                 className="text-green-600 hover:underline"
//                               >
//                                 Save
//                               </button>
//                               <button
//                                 onClick={() => handleCancel(file.id)}
//                                 className="text-gray-500 hover:underline"
//                               >
//                                 Cancel
//                               </button>
//                             </div>
//                           ) : (
//                             <div className="flex gap-2">
//                               <button
//                                 onClick={() => handleEditClick(file.id, rowIndex)}
//                                 className="text-blue-600 hover:underline"
//                               >
//                                 Edit
//                               </button>
//                               <button
//                                 onClick={() => handleDeleteRow(file.id, rowIndex)}
//                                 className="text-red-600 hover:underline"
//                               >
//                                 Delete
//                               </button>
//                             </div>
//                           )}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </>
//           )}
//         </div>
        
//       ))}
//       <div className="mb-4">
//         <select
//           value={selectedDate}
//           onChange={handleSelectDate}
//           className="p-2 border rounded"
//         >
//           <option value="">Select a date</option>
//           {uniqueDates.map((date) => (
//             <option key={date} value={date}>
//               {date}
//             </option>
//           ))}
//         </select>
//       </div>
//     </div>
//   );
// };

// export default UploadComponent;
// import React, { useState, useEffect } from 'react';
// import * as XLSX from "xlsx";
// import axios from "axios";

// const UploadComponent = () => {
//   const [filesData, setFilesData] = useState([]);

//   useEffect(() => {
//     const savedFiles = localStorage.getItem("uploadedFilesData");
//     if (savedFiles) {
//       setFilesData(JSON.parse(savedFiles));
//     }
//   }, []);

//   useEffect(() => {
//     if (filesData.length > 0) {
//       localStorage.setItem("uploadedFilesData", JSON.stringify(filesData));
//     }
//   }, [filesData]);

//   // const handleFileChange = (e) => {
//   //   const file = e.target.files[0];
//   //   if (!file) return;

//   //   const reader = new FileReader();

//   //   reader.onload = (event) => {
//   //     const binaryStr = event.target.result;
//   //     const workbook = XLSX.read(binaryStr, { type: "binary" });
//   //     const sheetName = workbook.SheetNames[0];
//   //     const sheet = workbook.Sheets[sheetName];
//   //     const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

//   //     const newFile = {
//   //       id: Date.now(),
//   //       fileName: file.name,
//   //       tableData: data,
//   //       submitted: false,
//   //     };
//   //     setFilesData([newFile]);
//   //   };

//   //   reader.readAsBinaryString(file);
//   //   e.target.value = "";
//   // };

//   const handleFileChange = (e) => {
//   const file = e.target.files[0];
//   if (!file) return;

//   const reader = new FileReader();

//   reader.onload = (event) => {
//     const binaryStr = event.target.result;
//     const workbook = XLSX.read(binaryStr, { type: "binary" });
//     const sheetName = workbook.SheetNames[0];
//     const sheet = workbook.Sheets[sheetName];
//     const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

//     // 🔍 Validation for duplicate (statecode + commoditycode + scheme)
//     const uniqueSet = new Set();
//     let hasDuplicate = false;


//     for (let row of data) {
//       const key = `${row.statecode}-${row.commoditycode}-${row.scheme}`;
//       if (uniqueSet.has(key)) {
//         hasDuplicate = true;
//         break;
//       }
//       uniqueSet.add(key);
//     }

//     if (hasDuplicate) {
//       alert("Duplicate combination of statecode, commoditycode, and scheme found!");
//       return;
//     }

//     const newFile = {
//       id: Date.now(),
//       fileName: file.name,
//       tableData: data,
//       submitted: false,
//     };

//     setFilesData([newFile]); // Optional: Change to [...filesData, newFile] to allow multiple files
//   };

//   reader.readAsBinaryString(file);
//   e.target.value = "";
// };


//   const handleFinalSubmit = async (fileId) => {
    
//     const file = filesData.find((f) => f.id === fileId);
//     try {
//       // const response = await axios.post("procurement/upload", file.tableData);
//  const response = await axios.post(`${process.env.REACT_APP_BASE_URL}procurement/upload`, file.tableData, {
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

//       console.log(response.data);
//       alert("File submitted successfully!");
//       updateFileData(fileId, { submitted: true });
//     } catch (error) {
//       console.error("Upload failed", error);
//       alert("Submission failed.");
//     }
//   };

//   const handleCancel = (fileId) => {
//     setFilesData((prev) => prev.filter((file) => file.id !== fileId));
//   };

//   const updateFileData = (id, updatedFields) => {
//     setFilesData((prev) =>
//       prev.map((file) =>
//         file.id === id ? { ...file, ...updatedFields } : file
//       )
//     );
//   };

//   return (
//     <div className="p-6 space-y-6">
//       <h2 className="text-2xl font-bold mb-2">Upload File</h2>

//       <input
//         type="file"
//         accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
//         onChange={handleFileChange}
//         className="file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
//       />

//       {filesData.map((file) => (
//         <div key={file.id} className="border p-4 rounded-md bg-gray-50">
//           <p className="font-medium mb-4">{file.fileName}</p>

//           {!file.submitted && (
//             <div className="mb-3 flex gap-3">
//               <button
//                 onClick={() => handleFinalSubmit(file.id)}
//                 className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
//               >
//                 Submit
//               </button>
//               <button
//                 onClick={() => handleCancel(file.id)}
//                 className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
//               >
//                 Cancel
//               </button>
//             </div>
//           )}

//           {file.submitted && <p className="text-green-600 font-medium">Submitted Successfully</p>}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default UploadComponent;
// import React, { useState } from 'react';
// import axios from 'axios';

// const UploadExcel = () => {
//   const [file, setFile] = useState(null);
//   const [message, setMessage] = useState("");
//   const [messageType, setMessageType] = useState(""); // 'success' or 'error'

//   const handleFileChange = (e) => {
//     const selected = e.target.files[0];
//     setFile(selected);
//     setMessage("");
//     setMessageType("");
//   };

//   const handleCancel = () => {
//     setFile(null);
//     setMessage("");
//     setMessageType("");
//   };

//   const handleSubmit = async () => {
//     if (!file) {
//       setMessage("Please select a file first.");
//       setMessageType("error");
//       return;
//     }

//     const user = JSON.parse(localStorage.getItem("user"));
//     const token = user?.token;

//     if (!token) {
//       setMessage("User not authenticated. Please login.");
//       setMessageType("error");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}procurement/upload`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'multipart/form-data',
//           },
//         }
//       );

//       setMessage("File uploaded successfully.");
//       setMessageType("success");
//       setFile(null);
//     } catch (err) {
//       // Extract correct message from response
//       const serverMessage =
//         err?.response?.data?.message ||
//         err?.response?.data?.error ||
//         err?.message ||
//         "Upload failed.";
        
//       setMessage(serverMessage);
//       setMessageType("error");
//     }
//   };

//   return (
//     <div className="p-6 max-w-md mx-auto bg-white rounded-xl shadow-md space-y-4 mt-10 border border-gray-300">
//       <h2 className="text-lg font-semibold text-center">Upload Excel File</h2>

//       {message && (
//         <div
//           className={`px-4 py-2 rounded text-sm ${
//             messageType === "success"
//               ? "bg-green-100 text-green-800"
//               : "bg-red-100 text-red-800"
//           }`}
//         >
//           {message}
//         </div>
//       )}

//       <input
//         type="file"
//         accept=".xlsx,.xls"
//         onChange={handleFileChange}
//         className="block w-full text-sm text-gray-700 file:mr-4 file:py-1 file:px-3 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#2dbfa8] file:text-white hover:file:bg-[#25a895]"
//       />

//       {file && (
//         <div className="flex justify-between items-center border px-3 py-2 rounded-md bg-gray-50">
//           <span className="text-sm text-gray-800 truncate">{file.name}</span>
//           <div className="flex gap-2">
//             <button
//               onClick={handleSubmit}
//               className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm"
//             >
//               Submit
//             </button>
//             <button
//               onClick={handleCancel}
//               className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UploadExcel;
// import React, { useState } from 'react';
// import axios from 'axios';
// import { CloudUpload, XCircle } from 'lucide-react';

// const UploadExcel = () => {
//   const [file, setFile] = useState(null);
//   const [message, setMessage] = useState("");
//   const [messageType, setMessageType] = useState(""); // 'success' or 'error'

//   const handleFileChange = (e) => {
//     const selected = e.target.files[0];
//     setFile(selected);
//     setMessage("");
//     setMessageType("");
//   };

//   const handleCancel = () => {
//     setFile(null);
//     setMessage("");
//     setMessageType("");
//   };

//   const handleSubmit = async () => {
//     if (!file) {
//       setMessage("Please select a file first.");
//       setMessageType("error");
//       return;
//     }

//     const user = JSON.parse(localStorage.getItem("user"));
//     const token = user?.token;

//     if (!token) {
//       setMessage("User not authenticated. Please login.");
//       setMessageType("error");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}procurement/upload`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'multipart/form-data',
//           },
//         }
//       );

//       setMessage("File uploaded successfully.");
//       setMessageType("success");
//       setFile(null);
//     } catch (err) {
//       const serverMessage =
//         err?.response?.data?.message ||
//         err?.response?.data?.error ||
//         err?.message ||
//         "Upload failed.";
//       setMessage(serverMessage);
//       setMessageType("error");
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
//       <div className="w-full max-w-lg bg-white shadow-xl rounded-xl p-8 space-y-6 border border-gray-200">
//         <h2 className="text-2xl font-semibold text-center text-gray-800">
//           Upload Excel File
//         </h2>

//         {message && (
//           <div
//             className={`p-3 rounded-md text-sm text-center ${
//               messageType === "success"
//                 ? "bg-green-100 text-green-700"
//                 : "bg-red-100 text-red-700"
//             }`}
//           >
//             {message}
//           </div>
//         )}

//         <label
//           htmlFor="file-upload"
//           className="flex items-center justify-center border-2 border-dashed border-gray-300 rounded-lg p-6 cursor-pointer hover:bg-gray-50 transition"
//         >
//           <CloudUpload className="w-6 h-6 text-blue-600 mr-2" />
//           <span className="text-gray-700">
//             {file ? file.name : "Click to select a file (.xlsx or .xls)"}
//           </span>
//           <input
//             id="file-upload"
//             type="file"
//             accept=".xlsx,.xls"
//             onChange={handleFileChange}
//             className="hidden"
//           />
//         </label>

//         {file && (
//           <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border rounded-md">
//             <span className="text-sm text-gray-800 truncate">{file.name}</span>
//             <div className="flex gap-2">
//               <button
//                 onClick={handleSubmit}
//                 className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded-md text-sm transition"
//               >
//                 Submit
//               </button>
//               <button
//                 onClick={handleCancel}
//                 className="bg-red-500 hover:bg-red-600 text-white px-3 py-1.5 rounded-md text-sm flex items-center gap-1 transition"
//               >
//                 <XCircle className="w-4 h-4" />
//                 Cancel
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default UploadExcel;
// import React, { useState } from 'react';
// import { CloudUpload, XCircle } from 'lucide-react';
// import axios from 'axios';

// const UploadExcel = () => {
//   const [file, setFile] = useState(null);
//   const [message, setMessage] = useState('');
//   const [messageType, setMessageType] = useState('');

//   const handleFileChange = (e) => {
//     const selected = e.target.files[0];
//     setFile(selected);
//     setMessage('');
//     setMessageType('');
//   };

//   const handleCancel = () => {
//     setFile(null);
//     setMessage('');
//     setMessageType('');
//   };

//   const handleSubmit = async () => {
//     if (!file) {
//       setMessage('Please select a file first.');
//       setMessageType('error');
//       return;
//     }

//     const user = JSON.parse(localStorage.getItem('user'));
//     const token = user?.token;

//     if (!token) {
//       setMessage('User not authenticated. Please login.');
//       setMessageType('error');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('file', file);

//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}procurement/upload`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'multipart/form-data',
//           },
//         }
//       );

//       setMessage('File uploaded successfully.');
//       setMessageType('success');
//       setFile(null);
//     } catch (err) {
//       const serverMessage =
//         err?.response?.data?.message ||
//         err?.response?.data?.error ||
//         err?.message ||
//         'Upload failed.';
//       setMessage(serverMessage);
//       setMessageType('error');
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
//       <div className="w-full max-w-lg bg-white shadow-xl rounded-xl p-8 space-y-6 border border-gray-200">
//         <h2 className="text-3xl font-bold text-center text-blue-900">
//           Upload Procurement
//         </h2>

//         {message && (
//           <div
//             className={`p-3 rounded-md text-sm text-center ${
//               messageType === 'success'
//                 ? 'bg-green-100 text-green-700'
//                 : 'bg-red-100 text-red-700'
//             }`}
//           >
//             {message}
//           </div>
//         )}

//         <label
//           htmlFor="file-upload"
//           className="flex items-center justify-center border-2 border-dashed border-[#2dbfa8] rounded-lg p-6 cursor-pointer bg-[#2dbfa8] text-white hover:bg-[#25a895] transition"
//         >
//           <CloudUpload className="w-6 h-6 mr-2" />
//           <span>
//             {file ? file.name : 'Click to select a file (.xlsx or .xls)'}
//           </span>
//           <input
//             id="file-upload"
//             type="file"
//             accept=".xlsx,.xls"
//             onChange={handleFileChange}
//             className="hidden"
//           />
//         </label>

//         {file && (
//           <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border rounded-md">
//             <span className="text-sm text-gray-800 truncate">{file.name}</span>
//             <div className="flex gap-2">
//               <button
//                 onClick={handleSubmit}
//                 className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded-md text-sm transition"
//               >
//                 Submit
//               </button>
//               <button
//                 onClick={handleCancel}
//                 className="bg-red-500 hover:bg-red-600 text-white px-3 py-1.5 rounded-md text-sm flex items-center gap-1 transition"
//               >
//                 <XCircle className="w-4 h-4" />
//                 Cancel
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default UploadExcel;
// import React, { useState } from 'react';
// import { CloudUpload, XCircle } from 'lucide-react';
// import axios from 'axios';

// const UploadExcel = () => {
//   const [file, setFile] = useState(null);
//   const [message, setMessage] = useState('');
//   const [messageType, setMessageType] = useState('');

//   const handleFileChange = (e) => {
//     const selected = e.target.files[0];
//     setFile(selected);
//     setMessage('');
//     setMessageType('');
//   };

//   const handleCancel = () => {
//     setFile(null);
//     setMessage('');
//     setMessageType('');
//   };

//   const handleSubmit = async () => {
//     if (!file) {
//       setMessage('Please select a file first.');
//       setMessageType('error');
//       return;
//     }

//     const user = JSON.parse(localStorage.getItem('user'));
//     const token = user?.token;

//     if (!token) {
//       setMessage('User not authenticated. Please login.');
//       setMessageType('error');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('file', file);

//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}procurement/upload`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'multipart/form-data',
//           },
//         }
//       );

//       setMessage('File uploaded successfully.');
//       setMessageType('success');
//       setFile(null);
//     } catch (err) {
//       const serverMessage =
//         err?.response?.data?.message ||
//         err?.response?.data?.error ||
//         err?.message ||
//         'Upload failed.';
//       setMessage(serverMessage);
//       setMessageType('error');
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4 py-16">
//       <div className="w-full max-w-xl bg-white shadow-2xl rounded-2xl p-10 space-y-6 border border-gray-300">
//         <h2 className="text-3xl font-bold text-center text-blue-900">
//           Upload Procurement
//         </h2>
  
//         {message && (
//           <div
//             className={`p-3 rounded-md text-sm text-center ${
//               messageType === 'success'
//                 ? 'bg-green-100 text-green-700'
//                 : 'bg-red-100 text-red-700'
//             }`}
//           >
//             {message}
//           </div>
//         )}
  
//         <label
//           htmlFor="file-upload"
//           className="flex items-center justify-center border-2 border-dashed border-[#2dbfa8] rounded-lg p-6 cursor-pointer bg-[#2dbfa8] text-white hover:bg-[#25a895] transition"
//         >
//           <CloudUpload className="w-6 h-6 mr-2" />
//           <span>
//             {file ? file.name : 'Click to select a file (.xlsx or .xls)'}
//           </span>
//           <input
//             id="file-upload"
//             type="file"
//             accept=".xlsx,.xls"
//             onChange={handleFileChange}
//             className="hidden"
//           />
//         </label>
  
//         {file && (
//           <div className="flex items-center justify-between px-4 py-3 bg-gray-50 border rounded-md">
//             <span className="text-sm text-gray-800 truncate">{file.name}</span>
//             <div className="flex gap-2">
//               <button
//                 onClick={handleSubmit}
//                 className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded-md text-sm transition"
//               >
//                 Submit
//               </button>
//               <button
//                 onClick={handleCancel}
//                 className="bg-red-500 hover:bg-red-600 text-white px-3 py-1.5 rounded-md text-sm flex items-center gap-1 transition"
//               >
//                 <XCircle className="w-4 h-4" />
//                 Cancel
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
  
//   };
  
//   export default UploadExcel;
  import React, { useState } from 'react';
import { CloudUpload, XCircle } from 'lucide-react';
import axios from 'axios';

const UploadExcel = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
    setMessage('');
    setMessageType('');
  };

  const handleCancel = () => {
    setFile(null);
    setMessage('');
    setMessageType('');
  };

  const handleSubmit = async () => {
    if (!file) {
      setMessage('Please select a file first.');
      setMessageType('error');
      return;
    }

    const user = JSON.parse(localStorage.getItem('user'));
    const token = user?.token;

    if (!token) {
      setMessage('User not authenticated. Please login.');
      setMessageType('error');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}procurement/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setMessage('File uploaded successfully.');
      setMessageType('success');
      setFile(null);
    } catch (err) {
      const serverMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        'Upload failed.';
      setMessage(serverMessage);
      setMessageType('error');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4 py-10 sm:py-16">
      <div className="w-full max-w-xl bg-white shadow-lg rounded-2xl p-6 sm:p-10 space-y-6 border border-gray-300">
        <h2 className="text-2xl sm:text-3xl font-bold text-center text-blue-900">
          Upload Procurement
        </h2>

        {message && (
          <div
            className={`p-3 rounded-md text-sm text-center transition-all ${
              messageType === 'success'
                ? 'bg-green-100 text-green-700'
                : 'bg-red-100 text-red-700'
            }`}
          >
            {message}
          </div>
        )}

        <label
          htmlFor="file-upload"
          className="flex items-center justify-center border-2 border-dashed border-[#2dbfa8] rounded-lg p-5 cursor-pointer bg-[#2dbfa8] text-white hover:bg-[#25a895] transition text-sm sm:text-base text-center"
        >
          <CloudUpload className="w-6 h-6 mr-2" />
          <span>{file ? file.name : 'Click to select a file (.xlsx or .xls)'}</span>
          <input
            id="file-upload"
            type="file"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
            className="hidden"
          />
        </label>

        {file && (
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 px-4 py-3 bg-gray-50 border rounded-md">
            <span className="text-sm text-gray-800 break-all w-full sm:w-auto">
              {file.name}
            </span>
            <div className="flex gap-2 w-full sm:w-auto justify-end">
              <button
                onClick={handleSubmit}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded-md text-sm transition"
              >
                Submit
              </button>
              <button
                onClick={handleCancel}
                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1.5 rounded-md text-sm flex items-center gap-1 transition"
              >
                <XCircle className="w-4 h-4" />
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadExcel;
